const RELEASE_META = 'meta[name="forecast-release"]'

export function installReleaseVersionHeader() {
  if (typeof window === 'undefined' || !window.fetch) return
  const releaseId = document.querySelector<HTMLMetaElement>(RELEASE_META)?.content
  if (!releaseId) return
  const originalFetch = window.fetch.bind(window)
  let refreshing = false
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const request = new Request(input, init)
    const url = new URL(request.url, window.location.href)
    if (url.origin !== window.location.origin || !(url.pathname === '/data' || url.pathname.startsWith('/data/'))) {
      return originalFetch(input, init)
    }
    const headers = new Headers(request.headers)
    headers.set('X-Forecast-Release', releaseId)
    const response = await originalFetch(new Request(request, { ...init, headers }))
    if (response.status === 410 && !refreshing) {
      refreshing = true
      window.location.reload()
    }
    return response
  }
}
